import type { ChatHistory } from 'types/chatbot';

const MAX_HISTORY_BYTES = 500 * 1024;

const estimateUtf16Bytes = (value: unknown): number => {
  try {
    const serialized = JSON.stringify(value);

    return (serialized?.length ?? 0) * 2;
  } catch {
    return 0;
  }
};

export const trimChatHistoryToStorageLimit = (history: ChatHistory[], maxBytes = MAX_HISTORY_BYTES): ChatHistory[] => {
  if (estimateUtf16Bytes(history) <= maxBytes) {
    return history;
  }

  let low = 0;
  let high = history.length;
  let bestFitLength = 0;

  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const candidateHistory = history.slice(0, mid);

    if (estimateUtf16Bytes(candidateHistory) <= maxBytes) {
      bestFitLength = mid;
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }

  return history.slice(0, bestFitLength);
};

export const upsertChatHistory = (history: ChatHistory[], chat: ChatHistory, maxBytes = MAX_HISTORY_BYTES): ChatHistory[] => {
  const updatedHistory = [chat, ...history.filter((item) => item.id !== chat.id)];

  return trimChatHistoryToStorageLimit(updatedHistory, maxBytes);
};

export const hasUserMessage = (messages: ChatHistory['messages']): boolean => messages.some((message) => message.role === 'user');
